import { LocalDataSource } from "../core";

export class UserLocalDataSource extends LocalDataSource {
  public getToken(): string | undefined {
    return this.getCookie("admin_token");
  }

  public setToken(token: string): void {
    this.setCookie("admin_token", token, 30);
  }

  public deleteToken(): void {
    this.deleteCookie("admin_token");
  }

  public hasToken(): boolean {
    const token = this.getToken();
    return token !== "" && token !== undefined;
  }
}
